import gql from "graphql-tag";

export default gql`
	mutation suspendUser($user_id: ID!) {
		suspendUser(userId: $user_id) {
			success
		}
	}
`;
